import React from 'react';
import './burger.scss';

var Burger = function Burger(_ref) {
  var onClick = _ref.onClick,
      isOpen = _ref.isOpen,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("button", {
    className: "burger " + (isOpen && 'burger--open') + " " + (className ? className : ''),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "burger__icon"
  }));
};

export default Burger;